import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isHostSelectedSelector, isSubmittingSelector } from '../../selectors';
import { setTouched } from '../../slice';
const containerCss = "cdcizk5";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const cancelButtonCss = "cwfrnkn";
const CancelButton = forwardRef((props, ref) => {
  const decoration = useDeviceType('isPhone') ? 'secondary-outline' : 'ghost';
  return <Button ref={ref} {...props} decoration={decoration} className={classNames(cancelButtonCss, props.className)} />;
});
export const Footer = ({
  onSubmit,
  onClose
}) => {
  const dispatch = useDispatch();
  const isSubmitting = useSelector(isSubmittingSelector);
  const isHostSelected = useSelector(isHostSelectedSelector);
  const handleSubmit = () => {
    if (!isHostSelected) {
      dispatch(setTouched(true));
      return;
    }
    onSubmit();
  };
  return <Container>
      <CancelButton onClick={onClose}>
        {I18n.t('publisher.action.cancel')}
      </CancelButton>
      <Button loading={isSubmitting} onClick={handleSubmit}>
        {I18n.t('publisher.action.apply')}
      </Button>
    </Container>;
};

require("./footer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");